const SimpleDeckMenuItem = ({ onClick, icon, title }) => {
  return (
    <div
      onClick={onClick}
      className="card min-h-44 max-w-md cursor-pointer border-b-4 border-solid border-transparent bg-base-300 text-primary-content shadow-lg hover:border-secondary lg:card-side"
    >
      <div className="card-body flex flex-row items-center justify-center">
        <div className="mr-3 flex flex-row justify-center gap-3">
          {icon}
          <p className="text-center text-lg font-bold text-base-content">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SimpleDeckMenuItem;
